import React, { useEffect, useState } from 'react';
import { useLoading } from '../../contexts/LoadingContext';

/**
 * Global Loader - Premium Advanced Animations
 * Powerful pure CSS animations, perfectly centered
 */
const GlobalLoader: React.FC = () => {
  const { isLoading } = useLoading();
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShouldRender(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsVisible(true);
        });
      });
    } else {
      setIsVisible(false);
      const timeout = setTimeout(() => setShouldRender(false), 400);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (!shouldRender) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        background: 'linear-gradient(135deg, rgba(250, 251, 252, 0.98) 0%, rgba(240, 244, 248, 0.98) 100%)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        zIndex: 999999,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      {/* Favicon (Absolute Center) */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '48px',
        height: '48px',
        margin: '-24px 0 0 -24px',
      }}>
        <img 
          src="/favicon.ico?v=5"
          alt="Fromas Loader" 
          className="fromas-loader"
          style={{
            width: '48px',
            height: '48px',
            display: 'block',
          }}
          onError={(e: any) => { 
            console.error('GlobalLoader: Favicon not found', e);
            e.target.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
};

export default GlobalLoader;
